import SavedSearchesModal from "./SavedSearchesModal";
export default SavedSearchesModal;
